import TID300Measurement from "./TID300Measurement";
import unit2CodingValue from "./unit2CodingValue";

/**
 * Expand an array of points stored as objects into
 * a flattened array of points
 *
 * @param points [{x: 0, y: 1}, {x: 1, y: 2}] or [{x: 0, y: 1, z: 0}, {x: 1, y: 2, z: 0}]
 * @return {Array} [point1x, point1y, point2x, point2y] or [point1x, point1y, point1z, point2x, point2y, point2z]
 */
function expandPoints(points) {
    const allPoints = [];

    points.forEach(point => {
        allPoints.push(point[0] || point.x);
        allPoints.push(point[1] || point.y);
        if (point[2] !== undefined || point.z !== undefined) {
            allPoints.push(point[2] || point.z);
        }
    });

    return allPoints;
}

export default class Polyline extends TID300Measurement {
    contentItem() {
        const {
            points,
            area,
            areaUnit = "mm2",
            ReferencedSOPSequence,
            use3DSpatialCoordinates = false,
            perimeter,
            unit = "mm"
        } = this.props;

        const GraphicData = expandPoints(points);

        const arg = [
            {
                RelationshipType: "CONTAINS",
                ValueType: "NUM",
                ConceptNameCodeSequence: {
                    CodeValue: "G-A166",
                    CodingSchemeDesignator: "SRT",
                    CodeMeaning: "Area"
                },
                MeasuredValueSequence: {
                    MeasurementUnitsCodeSequence: unit2CodingValue(areaUnit),
                    NumericValue: area
                },
                ContentSequence: [
                    {
                        RelationshipType: "INFERRED FROM",
                        ValueType: use3DSpatialCoordinates
                            ? "SCOORD3D"
                            : "SCOORD",
                        GraphicType: "POLYLINE",
                        GraphicData,
                        ContentSequence: use3DSpatialCoordinates
                            ? undefined
                            : {
                                  RelationshipType: "SELECTED FROM",
                                  ValueType: "IMAGE",
                                  ReferencedSOPSequence
                              }
                    }
                ].concat(this.getLabelLocationGroups())
            }
        ];
        if (perimeter) {
            arg.push({
                RelationshipType: "CONTAINS",
                ValueType: "NUM",
                ConceptNameCodeSequence: {
                    CodeValue: "G-A197",
                    CodingSchemeDesignator: "SRT",
                    CodeMeaning: "Perimeter"
                },
                MeasuredValueSequence: {
                    MeasurementUnitsCodeSequence: unit2CodingValue(unit),
                    NumericValue: perimeter
                },
                ContentSequence: {
                    RelationshipType: "INFERRED FROM",
                    ValueType: use3DSpatialCoordinates ? "SCOORD3D" : "SCOORD",
                    GraphicType: "POLYLINE",
                    GraphicData,
                    ContentSequence: use3DSpatialCoordinates
                        ? undefined
                        : {
                              RelationshipType: "SELECTED FROM",
                              ValueType: "IMAGE",
                              ReferencedSOPSequence
                          }
                }
            });
        }

        return this.getMeasurement(arg);
    }
}
